<template>
  <SectionY :padding="data.padding?.value">
    <ContainerX is-max class="mb-16 md:mb-24">
      <ClientOnly fallback-tag="span" fallback="Loading map...">
        <transition name="fade">
          <!-- SPINNER -->
          <div
            v-if="locations.length === 0"
            class="flex items-center justify-center"
          >
            <SpinIcon class="mr-2 h-5 w-5 animate-spin text-second-blue-300" />
            <span class="text-sm">Loading locations...</span>
          </div>
          <LocationsMap
            v-else
            ref="map"
            :locations="locations"
            class="aspect-video"
          />
        </transition>
      </ClientOnly>
    </ContainerX>
    <ContainerX is-max>
      <h2
        v-if="data.heading"
        class="mb-10 max-w-title font-sans-heavy text-lg md:mb-[5rem] md:text-2xl"
        v-html="$replaceHtmlTags(data.heading)"
      />
      <LocationsList
        :locations="locations"
        :countries="countries"
        @focus-location="$refs.map.focusLocation($event)"
      />
    </ContainerX>
  </SectionY>
</template>

<script setup>
import { useLocationsStore } from '@/stores/locations'
import { storeToRefs } from 'pinia'

const locationsStore = useLocationsStore()

// extract specific store properties
const { countries, locations } = storeToRefs(locationsStore)

defineProps({
  data: {
    type: Object,
    required: true,
  },
})

const map = ref(null)

async function fetchCountriesAndLocations() {
  const result = await GqlLocations({
    options: {
      lazy: true,
    },
  })

  if (!result) {
    console.error('Could not fetch locations in LocationsMapAndList.vue ')
  }

  countries.value = result.countries?.data
  locations.value = result.locations?.data
}
// INITIAL
if (!Array.isArray(countries.value) || !countries.value.length) {
  fetchCountriesAndLocations()
}
</script>
